import * as React from 'react';

import iconUrl from './index.svg';

interface IPriceHistoryDownIcon {
  className?: string;
}

export function PriceHistoryDownIcon(props: IPriceHistoryDownIcon) {
  const className = props.className || '';

  return <img className={className} width="11" height="14" src={iconUrl} alt="" />;
}
